module.exports = __webpack_public_path__ + "static/media/CircleLogo.fafcbe48.png";